export default __webpack_public_path__ + "static/media/attach_money.212359d5.svg";